function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M17,1H3C1.9,1,1,1.9,1,3v7c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V3C19,1.9,18.1,1,17,1z M3,8h3.1 c0.2,0.8,0.7,1.5,1.3,2H3V8z M17,10h-4.4c0.6-0.5,1.1-1.2,1.3-2H17V10z M17,6h-5v1c0,1.1-0.9,2-2,2S8,8.1,8,7V6H3V3h14V6z M15,13h-3 v1c0,0.5-0.2,0.9-0.5,1.2C11.1,15.7,10.6,16,10,16s-1.1-0.3-1.5-0.8C8.2,14.9,8,14.5,8,14v-1H1v4c0,1.1,0.9,2,2,2h14 c1.1,0,2-0.9,2-2v-4H15z M3,15h3.1c0,0.1,0.1,0.2,0.1,0.2c0.2,0.7,0.7,1.3,1.2,1.7H3V15z M17,17h-4.4c0.5-0.5,0.9-1.1,1.2-1.7 c0-0.1,0.1-0.2,0.1-0.2H17V17z"
});

var SvgStorage = function SvgStorage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStorage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storage.967ffaa0.svg";
export { ForwardRef as ReactComponent };